import { CategorySearchType } from 'src/common/enumerations/category-search-type';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { sellFoundItem } from 'src/search-products/business-logic/sell-found-item';
import { closeSearchModal, IsearchProps, showSearchModal } from '../search';

type SearchCallback = (itemLookup: IItemLookup, quantity: number, isWeight: boolean) => void;
export interface ISearchTransaction {
  submitCallback: (transactionId: string, touchPointId: string) => void;
  submitButtonText: string;
}

let _searchCallback: SearchCallback | undefined;

export const setSearchCallback = (searchCallback: SearchCallback) => {
  _searchCallback = searchCallback;
};

export const resetSearchCallback = () => {
  _searchCallback = undefined;
};

const handleSearch = (
  searchType: CategorySearchType,
  handleSearchResult: Function,
  submitButtonText: string = '',
) => {
  const searchProps: IsearchProps = {
    searchType,
    onClose: closeSearchModal,
    onSumbit: handleSearchResult,
    submitButtonText: submitButtonText,
  };
  showSearchModal(searchProps);
};

export const searchProduct = (): void => {
  const submitFoundProduct = (
    itemLookup: IItemLookup,
    quantity: number,
    isWeight: boolean,
  ): void => {
    closeSearchModal();
    if (_searchCallback) {
      _searchCallback(itemLookup, quantity, isWeight);
    } else {
      sellFoundItem(itemLookup, quantity, isWeight).catch(popupMessage);
    }
  };

  handleSearch(CategorySearchType.Products, submitFoundProduct);
};

export const searchTransaction = (params: ISearchTransaction): void => {
  handleSearch(CategorySearchType.Transactions, params.submitCallback, params.submitButtonText);
};
